import React, { FC, Ref, ReactNode } from 'react';
import Form from 'react-bootstrap/Form';
import { SelectionControl } from '../../../../core/components/SelectionControl';

interface CheckboxProps {
  checkClassName?: string;
  chakra?: string;
  children?: ReactNode;
  id?: string;
  inline?: boolean;
  inputClassName?: string;
  inputRef?: Ref<HTMLInputElement>;
  isChecked?: boolean;
  isDisabled?: boolean;
  labelClassName?: string;
  labelAction?: string;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (event: React.MouseEvent<HTMLInputElement>) => void;
  type?: any;
  value?: string;
  toggleDisplayType?: string;
  alignToggleItems?: string;
  toggleLabelSide?: string;
  [propName: string]: any;
}

export const Checkbox: FC<CheckboxProps> = props => {
  const {
    checkClassName,
    chakra,
    children,
    isDisabled,
    name,
    inputRef,
    id,
    onChange,
    onClick,
    labelAction,
    labelClassName,
    isChecked,
    inputClassName,
    type,
    value,
  } = props;

  const render = () => {
    // data-* attributes get applied via props, or inputProps for chakra
    if (chakra && chakra === 'off') {
      return (
        <Form.Check className={checkClassName}>
          <Form.Check.Label className={labelClassName} data-action={labelAction} htmlFor={id}>
            <Form.Check.Input
              {...props}
              checked={isChecked}
              className={inputClassName}
              disabled={isDisabled}
              id={id}
              ref={inputRef}
              name={name}
              onChange={onChange}
              onClick={onClick}
              type={type}
              value={value}
            />
            <i className="input-helper" />
            {children}
          </Form.Check.Label>
        </Form.Check>
      );
    } else {
      return <SelectionControl {...props} />;
    }
  };

  return <>{render()}</>;
};

Checkbox.displayName = 'Checkbox';
